import '../../../utils/index.mjs';
import { radioPropsBase } from './radio.mjs';
import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const radioButtonProps = buildProps({
  ...radioPropsBase
});

export { radioButtonProps };
//# sourceMappingURL=radio-button.mjs.map
